<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Expense/Reimbursement Claim</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">
                    Expense/Reimbursement Claim
                  </li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  class="btn add-btn"
                  @click="onSubmitForApproval"
                  v-if="
                    expense.status == 7 &&
                      expense.assignee == currentUser.employee.id
                  "
                  ><i class="fa fa-ticket"></i> Submit for Approval</a
                >
                <a
                  class="btn add-btn"
                  @click="setAdjust"
                  v-if="
                    expense.status == 1 &&
                      expense.amount != expense.approvedAmount &&
                      expense.assignee == currentUser.employee.id &&
                      !isAdjust
                  "
                  ><i class="fa fa-ticket"></i> Adjust Amount</a
                >
                <a
                  class="btn add-btn"
                  @click="submitAdjustment"
                  v-if="
                    expense.status == 1 &&
                      expense.amount != expense.approvedAmount &&
                      expense.assignee == currentUser.employee.id &&
                      isAdjust
                  "
                  ><i class="fa fa-ticket"></i> Submit Adjustment</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div class="accordion" id="accordionExample">
                  <div class="card mb-3">
                    <div class="card-header" id="headingOne">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <button class="btn collapsed">
                          General
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <form @submit.prevent="onSubmit">
                          <div class="d-flex justify-content-between mt-1">
                            <div></div>
                            <button
                              class="btn text-primary float-right mr-3"
                              v-if="
                                expense.assignee == currentUser.employee.id ||
                                  isManager
                              "
                            >
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />
                          <div class="row">
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Date
                                  <span class="text-danger">*</span></label
                                >
                                <div class="cal-icon">
                                  <datepicker
                                    v-model="expense.date"
                                    bootstrap-styling
                                    class="form-control datetimepicker"
                                    type="date"
                                    :disabled="
                                      currentUser.employee.id !==
                                        expense.assignee
                                    "
                                  />
                                  <!-- <input class="form-control datetimepicker" type="text"> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Expense Type
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  class="form-control"
                                  v-model="expense.expenseTypeId"
                                  :disabled="
                                    currentUser.employee.id !==
                                      expense.assignee ||
                                      expense.approvedByManager != null
                                  "
                                >
                                  <option>Select Type</option>
                                  <option
                                    v-for="item in expenseTypes"
                                    :key="item.id"
                                    :value="item.id"
                                    >{{ item.name }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-10">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model="expense.remark"
                                  :disabled="
                                    currentUser.employee.id !==
                                      expense.assignee ||
                                      expense.approvedByManager != null
                                  "
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label
                                  >Employee
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="expense.assignee"
                                  disabled
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label>
                                  Amount <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="expense.amount"
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label>
                                  Approved Amount
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="expense.approvedAmount"
                                  :disabled="expense.assignee == currentUser.employee.id"
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3" v-if="this.expenseId > 0">
                    <div class="card-header" id="headingTwo">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <button class="btn collapsed">
                          Expense Claim Lines ({{
                            expense.expenseClaimItems &&
                              expense.expenseClaimItems.length
                          }})
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseTwo"
                      class="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openDialogMeasurement"
                            class="btn text-primary ml-3"
                            v-if="expense.assignee == currentUser.employee.id"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="dialogMeasurement" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Add Expense Claim Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>

                            <div class="modal-body">
                              <form @submit.prevent="onSubmitMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Name
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="payeeName"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Phone Number
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="payeePhoneNumber"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Email
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="payeeEmail"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Expense Description
                                            <span class="text-danger">*</span>
                                          </label>
                                          <textarea
                                            type="text"
                                            rows="5"
                                            cols="7"
                                            class="form-control"
                                            v-model="payeeAddress"
                                          >
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Bank
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="payeeBankName"
                                          >
                                            <option>Select Bank</option>
                                            <option
                                              v-for="item in banks"
                                              :key="item.lookupValue"
                                              :value="item.lookupDescription"
                                            >
                                              {{ item.lookupDescription }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Account Number
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            v-model="payeeAccountNumber"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Amount
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="amount"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12" v-if="document && !file">
                                        <div class="form-group">
                                          <label>
                                            Document Url
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            v-model="document"
                                            readonly
                                          />
                                        </div>
                                      </div>
                                      <div class="col-sm-12" v-if="!document">
                                        <div class="form-group">
                                          <label
                                            >Upload Expense/Reimbursement
                                            Claim</label
                                          >
                                          <div class="custom-file">
                                            <input
                                              type="file"
                                              name="file"
                                              class="form-control"
                                              id="cv_upload"
                                              @change="onFilePicked"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-sm-3">
                                        <a
                                          @click="importExpensesClaim"
                                          v-if="file"
                                          class="btn btn-primary continue-btn"
                                          
                                        >
                                          Upload</a
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->

                        <!-- view Measurement Modal -->
                        <v-dialog v-model="viewModal" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Expense Claim Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeViewMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Name
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="expenseItem.payeeName"
                                            type="text"
                                            class="form-control"
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Phone Number
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="
                                              expenseItem.payeePhoneNumber
                                            "
                                            type="text"
                                            class="form-control"
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Email
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="expenseItem.payeeEmail"
                                            type="text"
                                            class="form-control"
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Expense Description
                                            <span class="text-danger">*</span>
                                          </label>
                                          <textarea
                                            type="text"
                                            rows="5"
                                            cols="7"
                                            class="form-control"
                                            disabled
                                            v-model="expenseItem.payeeAddress"
                                          >
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Bank
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            disabled
                                            v-model="
                                              expenseItem.payeeBankName
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Account Number
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            disabled
                                            v-model="
                                              expenseItem.payeeAccountNumber
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Amount
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            disabled
                                            v-model="expenseItem.amount"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button
                                    class="btn btn-primary submit-btn"
                                    @click="closeViewMeasurement"
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /view Measurement Modal -->

                        <!-- edit Measurement Modal -->
                        <v-dialog
                          v-model="dialogEditMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Edit Expense Claim Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onEditMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Name
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="expenseItem.payeeName"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Phone Number
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="
                                              expenseItem.payeePhoneNumber
                                            "
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Payee Email
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="expenseItem.payeeEmail"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Expense Description
                                            <span class="text-danger">*</span>
                                          </label>
                                          <textarea
                                            type="text"
                                            rows="5"
                                            cols="7"
                                            class="form-control"
                                            v-model="expenseItem.payeeAddress"
                                          >
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Bank
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="expenseItem.payeeBankName"
                                          >
                                            <option>Select Bank</option>
                                            <option
                                              v-for="item in banks"
                                              :key="item.lookupValue"
                                              :value="item"
                                            >
                                              {{ item.lookupDescription }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Account Number
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            v-model="
                                              expenseItem.payeeAccountNumber
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Amount
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="expenseItem.amount"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Measurement Modal -->

                        <v-dialog
                          v-model="dialogDeleteMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <button
                                  type="button"
                                  class="close"
                                  @click="closeDeleteMeasurement"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteMeasurement"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteMeasurement"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>

                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersM"
                                :items="expense.expenseClaimItems"
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.doc`]="{ item }">
                                  <a
                                    :href="item.document"
                                    v-if="item.document"
                                    target="_blank"
                                    class="btn btn-primary"
                                    ><i class="fa fa-link"></i
                                  ></a>
                                </template>
                                <template v-slot:[`item.amount`]="{ item }">

                                  <input
                                            type="number"
                                            class="form-control"
                                            v-model="item.amount"
                                            @change="(e) => setAmount(e, item)"
                                            v-if="isAdjust"
                                          />
                                  <span v-if="!isAdjust">{{ item.amount }}</span>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div class="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        class="dropdown-item"
                                        v-if="
                                          expense.status == 7 &&
                                            expense.assignee ==
                                              currentUser.employee.id
                                        "
                                        @click="openDialogEditMeasurement(item)"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Edit</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        v-if="
                                          expense.status == 7 &&
                                            expense.assignee ==
                                              currentUser.employee.id
                                        "
                                        @click="openDeleteMeasurement(item)"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openViewMeasurement(item)"
                                        ><i class="fa fa-eye m-r-5"></i> View</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import vueDynamicForms from "vuejs-dynamic-forms";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
    vueDynamicForms
  },
  data() {
    return {
      payeeName: "",
      payeePhoneNumber: "",
      payeeEmail: "",
      payeeAddress: "",
      payeeBankName: "",
      payeeAccountNumber: "",
      amount: "",
      document: "",
      expenseId: this.$route.params.id,
      expenseTypeId: 0,
      dialogMeasurement: false,
      dialogEditMeasurement: false,
      dialogDeleteMeasurement: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      headersM: [
        {
          text: "Payee Name",
          align: "start",
          value: "payeeName"
        },
        { text: "Payee Bank", value: "payeeBankName" },
        { text: "Payee Account No.", value: "payeeAccountNumber" },
        { text: "Amount", value: "amount" },
        { text: "", value: "doc", sortable: false },
        { text: "", value: "actions", sortable: false }
      ],
      banks: [],
      employees: [],
      isAdjust: false,
      expenseTypes: [],
      expense: {
        date: new Date(),
        assignee: authenticationService.currentUserValue
          ? authenticationService.currentUserValue.employee.id
          : 0,
        remark: "",
        expenseTypeId: 0,
        amount: 0,
        expenseClaimItems: []
      },
      expenseItem: {},
      message: "",
      error: "",
      file: null,
      fileName: "",
      isManager: null,
      viewModal: false,
      approvedAmount: 0
    };
  },
  methods: {
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },
    setAmount(event, item) {
      var i = this.expense.expenseClaimItems.findIndex(o => o.id = item.id)
      this.expense.expenseClaimItems[i].amount = parseFloat(event.target.value)
    },

    submitAdjustment() {
      var totalAdjusted = this.expense.expenseClaimItems.map(a => a.amount).reduce((a,b) => a + b)
      if(totalAdjusted != this.expense.approvedAmount){
        alert("Total Adjusted Amount is not same as Aprroved Amount, please kindly re-adjust")
        return
      }
      employeeService.adjustExpenseClaimItems(this.expense.expenseClaimItems).then(
          id => {
            this.isAdjust = false;
            this.getExpense();
            alert("Expense claims has been adjusted successfully")
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    setAdjust() {
      this.isAdjust = !this.isAdjust
    },

    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },

    importExpensesClaim() {
      employeeService.uploadFile(this.file).then(
        response => {
          console.log(response)
          this.document = response
          this.file = null
        },
        error => {
          this.error = error;
        }
      );
    },
    getBanks() {
      organizationService.getBanks().then(o => (this.banks = o));
    },
    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getTypes() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getExpenseType(companyId).then(
        model => {
          this.expenseTypes = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getExpense() {
      employeeService.getExpenseClaimById(this.expenseId).then(
        model => {
          console.log(model);
          this.expense = model;
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      if (this.expense.remark == "") {
        return (this.error = "Enter expense description");
      }

      this.loading = true;
      if (!this.expenseId) {
        this.expense.approvedAmount = this.expense.amount
        employeeService.addExpenseClaim(this.expense).then(
          id => {
            this.$router.push("/expense-claims-employee");
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      } else {
        employeeService.updateExpenseClaim(this.expense).then(
          id => {
            this.getExpense();
            alert("Expense claims has been updated successfully")
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      }
    },
    onSubmitForApproval() {
      this.expense.status = 0;
      employeeService.updateExpenseClaim(this.expense).then(
        id => {
          this.message = "Expense claim updated successfully";
          this.getExpense();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    onSubmitMeasurement() {
      this.expenseItem.payeeName = this.payeeName;
      this.expenseItem.payeePhoneNumber = this.payeePhoneNumber;
      this.expenseItem.payeeEmail = this.payeeEmail;
      this.expenseItem.payeeAddress = this.payeeAddress;
      this.expenseItem.payeeBankName = this.payeeBankName;
      this.expenseItem.payeeAccountNumber = this.payeeAccountNumber;
      this.expenseItem.amount = this.amount;
      this.expenseItem.document = this.document;
      if (
        this.payeeName == "" &&
        this.payeePhoneNumber == "" &&
        this.payeeEmail == "" &&
        this.payeeAddress == "" &&
        this.payeeBankName == "" &&
        this.payeeAccountNumber == "" &&
        this.amount == ""
      ) {
        this.error = "Fill all compulsory field";
      } else {
        this.expenseItem.expenseClaimId = this.expenseId;
        employeeService.addExpenseClaimItem(this.expenseItem).then(
          model => {
            this.closeMeasurement();
            this.expenseItem = {};
            this.getExpense();
          },
          error => {
            this.error = error;
          }
        );
        console.log("jaj");
      }
    },
    onEditMeasurement() {
      employeeService.updateExpenseClaimItem(this.expenseItem).then(
        model => {
          this.closeEditMeasurement();
          this.expenseItem = {};
          this.getExpense();
        },
        error => {
          this.error = error;
        }
      );
    },
    onDeleteMeasurement() {
      employeeService
        .removeExpenseClaimItem(this.expenseItem.expenseClaimId)
        .then(model => {
          this.getExpense();
          this.expenseItem = {};
          this.closeDeleteMeasurement();
        });
    },
    closeDeleteMeasurement() {
      this.dialogDeleteMeasurement = false;
    },
    closeMeasurement() {
      this.dialogMeasurement = false;
    },
    closeEditMeasurement() {
      this.dialogEditMeasurement = false;
    },
    openDialogMeasurement() {
      this.message = "";
      this.error = "";
      this.dialogMeasurement = true;
    },
    openDialogEditMeasurement(item) {
      this.message = "";
      this.error = "";
      console.log(`item`, item);
      this.expenseItem = item;
      this.dialogEditMeasurement = true;
    },
    openDeleteMeasurement(item) {
      this.expenseItem = item;
      this.dialogDeleteMeasurement = true;
    },
    openViewMeasurement(item) {
      this.viewModal = true;
      this.expenseItem = item;
    },
    closeViewMeasurement() {
      this.viewModal = false;
    }
  },
  mounted() {
    this.getTypes();
    this.getEmployees();
    this.getBanks();
    this.getExpense();
    this.isEmployeeManager();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/expenses/Expense/detail2.vue